









import { Component, Vue } from 'vue-property-decorator';
import PageHeader from '@/shared/components/pageHeader/PageHeader.vue';
import {TabItem} from '@/shared/components/pageHeader/tabItem';
import {Getter} from 'vuex-class';
import { ATTENDANT_TRIAGE_FLOWS_ENABLED, NLP_ENABLED } from '@/store/app/featureTypes';
import BotPreviewModal from '@/features/bots/components/botTestTool/BotPreviewModal.vue';
import appInsights from '@/shared/services/appInsights';
import WorkspaceViewModel from '@/workspaces/models/workspaceViewModel';
import UpgradeBanner from '@/features/bots/components/UpgradeBanner.vue';
import { HeaderButton } from '@/shared/components/pageHeader/headerButton';

@Component({
	components: {UpgradeBanner, PageHeader, BotPreviewModal},
})
export default class Bots extends Vue {
	@Getter public isWorkspaceFeatureEnabled!: (key: string) => boolean;
	@Getter public currentWorkspace!: WorkspaceViewModel;
	public botPreviewActive = false;

	public get tabs(): TabItem[] {
		const tabs = [];

		if (this.isWorkspaceFeatureEnabled(ATTENDANT_TRIAGE_FLOWS_ENABLED)) {
			tabs.push({ name: 'Tasks', route: 'bots-tasks'});
		}

		tabs.push({ name: 'Flows', route: 'bots-flows'});

		if (this.isWorkspaceFeatureEnabled(NLP_ENABLED)) {
			tabs.push({ name: 'FAQs', route: 'bots-answers'});
			tabs.push({ name: 'Intents', route: 'bots-intents'});
			tabs.push({ name: 'Active Learning', route: 'bots-active-learning'});
		}

		return tabs;
	}

	public get buttons(): HeaderButton[] {
		return [{
			clickHandler: () => this.openBotPreviewModal(),
			content: 'Preview your Bot',
			variant: 'secondary'
		}];
	}

	public openBotPreviewModal() {
		this.botPreviewActive = true;
		appInsights.trackEvent({ name: 'Preview your Bot clicked' }, { workspaceId: this.currentWorkspace.id });
	}

	public closeBotPreviewModal() {
		this.botPreviewActive = false;
	}
}
